<template>
<div class="bg-white px-3 py-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
	<div class="">
      <el-form inline ref="form" :model="searchform">


        


         

        <el-form-item class="mb-0 mr-0">
             <el-select v-model="searchform.value2" placeholder="상태선택" size="mini" style="width:90px" >
               <el-option
                      v-for="item in searchform.searchOptions2"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
              </el-select>
          </el-form-item>

          <el-form-item class="mb-0 mr-0">
             <el-select v-model="searchform.value" placeholder="타이틀선택" size="mini" style="width:100px" >
               <el-option
                      v-for="item in searchform.searchOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
              </el-select>
          </el-form-item>


          <el-form-item class="mb-0 mr-0">
             <el-input placeholder="키워드" v-model="searchform.keyword" size="mini" style="width:120px" ></el-input>
          </el-form-item>
          <el-form-item  class="mb-0 mr-0">
             <el-date-picker
                  v-model="searchform.time"
                  type="daterange"
                  range-separator="~"
                  start-placeholder="시작"
                  end-placeholder="마감" size="mini" class="mr-2" value-format="yyyy-MM-dd" style="width:200px">
                </el-date-picker>
          </el-form-item>
          <el-form-item class="mb-0 mr-0">
            <el-button type="info" size="mini" @click="searchEvent">검색</el-button>  
          </el-form-item>
      </el-form>
       
     
    
      
        
    </div>
	<div class="d-flex align-items-center mt-2">
		
		<el-button type="danger" size="mini" @click="deleteAll">선택환불</el-button>
   <div class="text-muted ml-2"><span class="text-danger mr-2">경기전:{{formatMoney(buy_good0)}}</span>|<span class="text-primary ml-2 mr-2">전금액:{{formatMoney(buy_good0_sum)}}</span>|<span class="text-info ml-2 mr-2">배팅:{{formatMoney(total_money)}}</span>|<span class="text-success ml-2 mr-2">적중:{{formatMoney(total_emoney)}}</span>|<span class="text-danger ml-2">차액:{{formatMoney(minus)}}</span></div>
		
	
	</div>
   

  <el-table
      :data="tableData"
       v-loading="loading"
       style="width: 100%"
       border class="mt-2"
       empty-text="데이타가 없습니다" @selection-change="handleSelectionChange" >
    

   
     <el-table-column
      type="selection"
      width="55"
      align="center"  >
    </el-table-column> 
   

    
   
       <el-table-column
        
        label="이름" prop="mem_name" align="center">
      </el-table-column>
       <el-table-column
        
        label="아이디" prop="mem_id" align="center" width="100">
          <template slot-scope="scope">
            
             <el-button type="text" @click="openModel(scope)">{{scope.row.mem_id}}</el-button>
          </template>
      </el-table-column>

           <el-table-column
        
        label="부본사/총판/추천인" prop="b_code" align="center" width="150">
        <template slot-scope="scope">
          {{scope.row.b_code}}-{{scope.row.a_code}}-{{scope.row.m_cp}}
        </template>
      </el-table-column>
      

       <el-table-column
        
        label="회차" prop="buy_num" align="center">


          <template slot-scope="scope">
          {{scope.row.game_type ? "EOS":""}} {{scope.row.buy_num}}
        </template>

      </el-table-column>


      <el-table-column
        
        label="구분" prop="buy_gubun" align="center">
        <template slot-scope="scope">
         <div v-if="scope.row.buy_good === '0' && scope.row.gn_p==1"><el-button type="primary"  size="mini" @click="goodUp(scope,3)" :disabled="disabled">적특</el-button></div>
         {{game_codes[scope.row.game_code]}}{{scope.row.buy_gubun}}
        
        </template>

      </el-table-column>
      


     

      
     
      <el-table-column
        
        label="상태" prop="buy_good" align="center" width="100">
         <template slot-scope="scope">
          <span v-if="scope.row.buy_good === '0'" class="text-primary">경기전</span>
          <span v-if="scope.row.buy_good === '1'" class="text-danger">적중</span>
          <span v-if="scope.row.buy_good === '2'">비적중</span>
          <span v-if="scope.row.buy_good === '5'" class="text-success">환불</span>
          <span v-if="scope.row.buy_good === '3'" class="text-success">적특</span>
        </template>
      </el-table-column>

     


     
     
       <el-table-column
        
        label="아이피" prop="buy_ip" align="center">
      </el-table-column>
       <el-table-column
        
        label="구매시간" prop="buy_time" align="center">
        <template slot-scope="scope">{{ scope.row.buy_time}}</template>
      </el-table-column>
       
       <el-table-column
        
        label="이전잔액" prop="ocs" align="center">
        <template v-if="scope.row.ocs >0 " slot-scope="scope">{{ formatMoney(scope.row.ocs)}}</template>
      </el-table-column>
       <el-table-column
        
        label="이전롤링" prop="c_m" align="center">
        <template v-if="scope.row.c_m >0 " slot-scope="scope">{{ formatMoney(scope.row.c_m)}}</template>
      </el-table-column>
       
      
      
		
		  
	
		 
    </el-table>
     <div style="height: 100px;"></div>
                      <el-footer class="border-top d-flex align-items-center px-0 position-fixed bg-white" style="bottom: 0;left: 200px;right: 0;z-index: 100;">
				  <div style="flex: 1;" class="px-2">
					  <el-pagination
					  :current-page="currentPage"
					  :page-sizes="[5, 10, 15, 20]"
					  :page-size="size"
					  layout="prev, pager, next"
					  :total="total"
					  @size-change="handleSizeChange"
      				  @current-change="handleCurrentChange">
					</el-pagination>
				  </div>
				</el-footer>	
          <id-dialog 
                :visible.sync="idDialogVisible"
                @cancelData="cancelData"
                @handleClose="handleClose"
                
                :formLoading="formLoading"
                ref="addForm">
                  
        </id-dialog>
				
</div>
 </template>

 <script>
 import idDialog from '../../components/common/id-dialog.vue';

    export default {
     components: {
      idDialog
    },
    	data(){
    		return{
          disabled:false,
          domain:window.sessionStorage.getItem('domain'),
          sitetype:window.sessionStorage.getItem('sitetype'),
          outbet:window.sessionStorage.getItem('outbet'),
          bg:window.sessionStorage.getItem('bg'),
          formLoading:false,
          idDialogVisible: false,
    		  buy_good0:'',
          buy_good0_sum:'',
          total_emoney:'',
          total_money:'',
          game_codes:{
              'PWB_NB_MIX':'일반조합-',
              'PWB_PB_MIX':'파워조합-',
              'PWB_NBPB_MIX':'',
              'PWB':'',
              'PWB_NBPB_MIX3':'',             
            },
    			options: [{
	              label: '대기',
	              value: '1',
	             
	            }, {
	              label: '처리중',
	               value: '2',
	              
	            }, {
	              label: '완료',
	               value: '3',
	             
	            }, {
	              label: '취소',
	               value: '4',
	             
	            }], 
    			searchform:{
    				keyword:'',
    				time:[],
    				searchOptions:[
                
    				{
		        	label:'구매자',
		        	value:'mem_name'
		        },
		        {
		        	label:'아이디',
		        	value:'mem_id'
		        },
		        {
		        	label:'회차',
		        	value:'buy_num'
		        },
		        {
		        	label:'총판',
		        	value:'a_code'
		        },
		        {
		        	label:'부본사',
		        	value:'b_code'
		        },
		       

		        ],
		        searchOptions2:[
                
    				{
		        	label:'전체',
		        	value:''
		        },{
		        	label:'적중',
		        	value:'1'
		        },
		        
		        {
		        	label:'비적중',
		        	value:'2'
		        },
             {
              label:'적특',
              value:'3'
            },
		        {
		        	label:'경기전',
		        	value:'0'
		        },
		      	{
		        	label:'환불',
		        	value:'5'
		        },
		        ],
            searchOptions3:[
            {
              label:'전체',
              value:''
            },
            {
              label:'파워볼',
              value:'PWB'
            },
            {
              label:'일반볼 조합',
              value:'PWB_NB_MIX'
            },
            {
              label:'파워볼 조합',
              value:'PWB_PB_MIX'
            },
            {
              label:'파워일반 조합',
              value:'PWB_NBPB_MIX'
            },
            {
              label:'모든조합',
              value:'mix'
            },
            {
              label:'사다리',
              value:'PSA'
            }
            ],
             searchOptions4:[
            {
              label:'전체',
              value:''
            },
            {
              label:'동행',
              value:'lotte'
            },
            {
              label:'EOS',
              value:'eos'
            },
            
            ],
		        value:'',
		        value2:'',
            value3:'',
            value4:'',


    			},
    			 pickerOptions: {
    			},
          shortcuts: [{
            text: '최근한주',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '최근한달',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '최근3개월',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }],
        
    
        valueOption:'아이디',
    			
		        
    		
		    		 total:0,
		    		 size:0,
		    		 loading: false,
		    		 editIndex:-1,
		    		 creatModel:false,
		    		 tableData: [],
			         currentPage:1,
			         multipleSelection:[],
			        
			         
			 
    			}
    			
    			
    		},
    		created() {
    			

    			this.getList();
    			
			
		},
    computed:{
      minus(){
        return this.total_money - this.total_emoney
      }

    },
    	
    	methods:{
      getSummaries (param) {
          const { columns, data } = param
          const sums = []
          columns.forEach((column, index) => {
          if (index === 1) {
           sums[index] = '总计'
          } else if (index === 7 || index === 9 || index === 11) {
           const values = data.map(item => Number(item[column.property]))
           if (!values.every(value => isNaN(value))) {
           sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr)
            if (!isNaN(value)) {
            return prev + curr
            } else {
            return prev
            }
           }, 0)
           } else {
           sums[index] = 'N/A'
           }
          } else {
           sums[index] = '--'
          }
          })
          return sums
         },
          // 关闭弹框（头部的X）
        
        handleClose () {
               this.idDialogVisible = false
            },
        cancelData(){
          this.idDialogVisible = false
        },
    			 // 搜索事件
			searchEvent(){

                if(this.searchform.keyword!='' && this.searchform.value == ''){
                	 this.$message('검색타이틀 선택하세요');
                	 return;
                }

              
            
this.currentPage=1;

    			this.getList();
    			
             

    		},
    		 handleSizeChange(val) {
			        //console.log(`每页 ${val} 条`);
			        this.size = val
			        this.getList();
			        this.loading= true

			      },
			      handleCurrentChange(val) {
			        //console.log(`当前页: ${val}`);
			        this.currentPage = val
			        this.getList();
			        this.loading= true
			      },
			     handleSelectionChange(val) {
          //console.log(val)
                this.multipleSelection = val;

      },
       openModel(e){
          this.idDialogVisible = true
          this.formLoading = true
          let token=window.sessionStorage.getItem('user');
          let that=this
          this.$axios({
                  method:'get',
                  // url:this.domain+'/api/admin/mem_cp_list2?fit='+this.prop+'&order='+this.order,
                   url:this.domain+'/admin/mem?fit='+this.prop+'&order='+this.order+'&mem_id='+e.row.mem_id,

                  'Accept': 'application/json',
                  headers: { 'Authorization': 'Bearer ' + token },
    
            }).then((response) =>{ 
                   this.formLoading = false
                   let data = response.data.data
                   //console.log('usersdata:',data)

                   //console.log('mem_status:',data.mem_status)
                   //console.log('addForm:',data.memState)
                   // this.$refs.addForm.form.mem_status = data.mem_status
                  // this.$refs.addForm.form.memState = data.memState
                   this.$refs.addForm.form = {
                      id_txt: data.id_txt,
                      bet_black : data.bet_black,
                      ref:data.ref,
                      mem_name:data.mem_name,
                      mem_hp:data.mem_hp,
                       color:data.RaceYN,
                        sitetype:this.sitetype,
                      mem_ing:data.mem_ing,
                      mem_login:data.mem_login,
                      mem_id:data.mem_id,
                      mem_pw:data.mem_pw,
                      mem_bankcode:data.mem_bankcode,
                      mem_banknum: data.mem_banknum,
                      mem_bankname:data.mem_bankname,
                       bg:this.bg,
                      event_loing1:data.event_loing1,
                      event_loing_recom1:data.event_loing_recom1,
                      event_loing_group1:data.event_loing_group1,
                      event_loing_group_recom1:data.event_loing_group_recom1,

                      event_loing_s1:data.event_loing_s1,
                      event_loing_recom_s1:data.event_loing_recom_s1,
                      event_loing_group_s1:data.event_loing_group_s1,
                      event_loing_group_recom_s1:data.event_loing_group_recom_s1,
                      mem_jumin:data.mem_jumin,
                       mem_email:data.mem_email,
                      mem_zip:data.mem_zip,
                      max_bet:data.max_bet,
                      m_emoney:data.m_emoney,
                      bet_black1 : data.bet_black1,
                      bet_black2 : data.bet_black2,
                      bet_black3 : data.bet_black3,
                      bet_black4 : data.bet_black4,
                      event_boat_sambok : data.event_boat_sambok,
                      event_bokyeon : data.event_bokyeon,
                      event_cycle_sambok : data.event_cycle_sambok,
                      event_japan_sambok : data.event_japan_sambok,
                      event_japan_samsang : data.event_japan_samsang,
                      event_pro : data.event_pro,
                      event_pro_boat : data.event_pro_boat,
                      event_pro_cycle : data.event_pro_cycle,
                      event_pro_japan : data.event_pro_japan,
                      event_sambok : data.event_sambok,
                      event_sang : data.event_sang,
                      login_more : data.login_more,
                      t_delay:data.t_delay,
                      mem_regdate:data.mem_regdate,
                      mem_cash:data.mem_cash,
                      mem_eventmoney:data.mem_eventmoney,
                      mem_ip:data.mem_ip,
                      mem_raip:data.mem_raip,
                      m_cp:data.m_cp,
                      mem_all_init:data.mem_all_init,
                      mem_memo:data.mem_memo,
                      mem_status:data.mem_status,
                       memState:data.memState,
                      loging:data.loging,
                      logip:data.logip,
                      mem_login_date:data.mem_login_date,
                      a_code:data.a_code,
                       event_loing_recom_e:data.event_loing_recom_e,
                      event_loing_recom_slot:data.event_loing_recom_slot,
                      event_loing_e:data.event_loing_e,
                      event_loing_slot:data.event_loing_slot,
                      c_code:data.c_code,
                      last_money_date:data.last_money_date,
                      in_money:data.in_money,
                      out_money:data.out_money,
                      reset_money:data.reset_money,
                      event_loing:data.event_loing,
                      event_loing_recom:data.event_loing_recom,
                      event_loing_group:data.event_loing_group,
                      event_loing_group_recom:data.event_loing_group_recom,
                      last_out_money_date:data.last_out_money_date,
                      reg_code:data.reg_code,
                      out_bet_power:data.out_bet_power,
                      out_bet_power_g:data.out_bet_power_g,
                      out_bet_sadari:data.out_bet_sadari,
                      out_bet_sadari_g:data.out_bet_sadari_g,
                      event_loing_s:data.event_loing_s,
                      event_loing_recom_s:data.event_loing_recom_s,
                      event_loing_group_s:data.event_loing_group_s,
                      event_loing_group_recom_s:data.event_loing_group_recom_s,
                      b_code:data.b_code,
                    }

                   
                     
               
            }).catch((error) =>{
                 console.log('error',error.response)   //请求失败返回的数据
            })
        },
       // 批量删除
      deleteAll(){
        this.$confirm('환불하시겠습니까?', '알림', {
          confirmButtonText: '환불',
          cancelButtonText: '취소',
          type: 'warning'
        }).then(() => {
          let token=window.sessionStorage.getItem('user');

          console.log('hh',this.multipleSelection);

                    let newids=[];

           this.multipleSelection.forEach(item=>{
            
            console.log('id',item.id);
            newids.push(item.id);
           });

           console.log('newids',newids);

          this.$axios({
                      method:'post',
                      data:newids,
                      url:this.domain+'/admin/bet_up_new',
                      'Accept': 'application/json',
                      headers: { 'Authorization': 'Bearer ' + token },
                      
                     
                  }).then((response) =>{ 
                    
                    if(response.data.code==200){
                      this.$message({
                      message:response.data.msg,
                      type:'success'
                    })
                    }else
                    {
                        this.$message({
                         message:response.data.msg,
                          type:'error'
                        })
                    }
                    this.getList()
    
                  }).catch((error) =>{
                      console.log(error)       //请求失败返回的数据
                  })
                  
       

          })

        
      },  
    		getList(){

    		

               let s_time="";
               let e_time="";

               if(this.searchform.time.length>0)
               {
                  s_time=this.searchform.time[0];
                  e_time=this.searchform.time[1];
               }

              
    			this.loading = true

    			 let token=window.sessionStorage.getItem('user');
    				//console.log(token);
    			 let urls=this.domain+'/admin/betlistgro?game_type='+this.searchform.value4+'&game_code='+this.searchform.value3+'&buy_good='+this.searchform.value2+'&s_time='+s_time+'&e_time='+e_time+'&'+this.searchform.value+'='+this.searchform.keyword+'&page='+this.currentPage;

    			this.$axios({
	                method:'get',
	                url:urls,
	                'Accept': 'application/json',
	                 headers: { 'Authorization': 'Bearer ' + token },
                
               
            }).then((response) =>{ 

                     let newdata=[];

                     　

                     
                  
                     let data = response.data.data
                     let ku=0;


                     data.data.forEach((item, i) => {

                        let newitem={
                            'mem_id':'',

                           
                            'mem_name': '배팅:'+this.formatMoney(item.buy_money*4)+'원;당첨:'+this.formatMoney(item.buy_emoney),
                            'gubun': '',
                            'buy_good': '',
                            'buy_time': '',
                        };


                       
                        newdata[i+ku]=item
                       // console.log('item',item);

                        if(i>0 && (i+1)%4==0)
                        {
                           ku=ku+1;
                        //   console.log('ku',ku);
                           newdata[i+ku]=newitem

                        }


                        
                     });

                    // console.log('new',newdata);


                     this.tableData =newdata
                     this.total = data.total
                     this.currentPage = data.current_page
                     this.size =data.per_page
                     this.buy_good0 = response.data.buy_good0
                     this.buy_good0_sum = response.data.buy_good0_sum
                     this.total_emoney = response.data.total_emoney
                     this.total_money = response.data.total_money
                     this.loading =false
               
            }).catch((error) =>{
            
               this.$message.error(error);
               this.loading = false
               
            })
    		},
    	 goodUp(e,v){


           this.disabled = true
           let token=window.sessionStorage.getItem('user');
           this.$axios({
                  method:'post',
                  url:this.domain+'/admin/good_up',
                  data:{
                    id:e.row.id,
                    old:0,
                    good:v
                  },
                  'Accept': 'application/json',
                   headers: { 'Authorization': 'Bearer ' + token },

            }).then((response) =>{ 
              console.log(response)
              if(response.data.code==200)
                      {
                         this.$message({
                          message:response.data.msg,
                          type: 'success'
                        });

                           this.getList()

                          
                      }else{
                       this.$message.error(response.data.msg)

                      }
                      this.disabled = false


               
            }).catch((error) =>{
             
             console.log('error',error.response)       //请求失败返回的数据
               
            })
        },
    		
    	
    		
    	}
  }
</script>

 <style scoped>
 /deep/ .el-form-item__content{
    display:flex;
    align-items:center;
    line-height:30px;
 }
 /deep/ .el-dialog{
    height:700px;overflow-y:scroll
 }
 /deep/ .el-input__inner{
  height:30px;
  line-height:30px;
 }
 /deep/ .el-form-item__label{
  line-height:30px;
 }
 /deep/ .el-dialog__body{
  padding:10px 20px
 }

</style>


// WEBPACK FOOTER //
// src/views/ordergro/list.vue